import ApiService from "../../ApiService";

const MyActivityService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/bbs/myactivity/loadscreenview", vo, successCallback, failureCallback);
    },
    loadMorePost: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/bbs/myactivity/loadmorepost", vo, successCallback, failureCallback);
    },
    loadMoreReply: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/bbs/myactivity/loadmorereply", vo, successCallback, failureCallback);
    },
    loadMoreFavourite: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/bbs/myactivity/loadmorefavourite", vo, successCallback, failureCallback);
    },
};

export default MyActivityService;
